/**
 * Shim for @ally/which-env
 *
 * @ally/which-env detects environment from window.location.hostname using
 * regex patterns: /.*-qa1/, /.*-qa2/, etc. These match "secure-qa1.ally.com"
 * but do NOT match "wealth-qabi1.invest.int.ally.com" (hostname has "-qabi1"
 * not "-qa1"). Without this shim, wealth-qabi* resolves as "prod", causing:
 *
 * - @ally/transmitigator's RiskID to target secure.ally.com (prod)
 * - clientID to use the prod value
 * - DEFAULT_SERVER to resolve as prod
 *
 * This shim normalizes "qabi1" → "qa1" and "qabi2" → "qa2" before passing
 * to the real which-env implementation.
 */

// @ts-ignore — direct file path bypasses the alias
import realModule from '../../node_modules/@ally/which-env/dist/index.js';

const realWhichEnv: (href?: string, envs?: [string, RegExp][]) => any =
  typeof realModule === 'function' ? realModule : (realModule as any).default;

function normalizeHref(href: string): string {
  try {
    const url = new URL(href);
    if (url.hostname.includes('qabi1')) {
      url.hostname = 'secure-qa1.ally.com';
    } else if (url.hostname.includes('qabi2')) {
      url.hostname = 'secure-qa2.ally.com';
    }
    return url.href;
  } catch {
    return href;
  }
}

function whichEnv(href?: string, envs?: [string, RegExp][]) {
  const resolved = href ?? window.location.href;
  return realWhichEnv(normalizeHref(resolved), envs);
}

// @ts-ignore
export const getProdSides = realModule.getProdSides;
// @ts-ignore
export const ProdDirectURL = realModule.ProdDirectURL;
// @ts-ignore
export const ProdSideKey = realModule.ProdSideKey;

export default whichEnv;
